// extracted by mini-css-extract-plugin
module.exports = {"background":"V_dS","values":"V_dT"};